// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___RIz3O","root__input":"style-module__root__input___zZxiR","root__label":"style-module__root__label___ETiVQ","root__highlight":"style-module__root__highlight___e9BIc"};
    if(module.hot) {
      // 1697460472195
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  